// Ported (narrowed) from nenda-autoplayer's src/lib/clients/NendaLogClient.ts.
// Only the fields actions.ts actually populates (see its own `log`/`logPlay`/
// `logPing`/etc. call sites) - the full upstream entry also carries several
// device-identity fields (deviceId, serialNumber, appVersion, ...) that its
// own client fills in itself before POSTing, not fields callers set directly.
export enum LogLevel {
  INFO = "INFO",
  WARNING = "WARNING",
  SEVERE = "SEVERE",
}

export enum AssetType {
  ContentChannel = "ContentChannel",
  SignagePlaylist = "SignagePlaylist",
  Signage = "Signage",
  Advertisement = "Advertisement",
  LocalFallback = "LocalFallback",
}

export interface NendaLogEntry {
  roomId?: string;
  premiseId?: string;
  level: LogLevel;
  component: string;
  currentAssetId?: string;
  currentAssetName?: string;
  currentAssetType?: AssetType;
  message?: string;
}
